// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    ICheckoutBootstrapResult,
}                               from '../interfaces';

const checkoutBootstrap = async ({
    test,
}: {
    test: boolean,
}): Promise<ICheckoutBootstrapResult> => {
    const functions = getFunctions();
    const handleCheckoutBootstrap = httpsCallable<
        Record<
            string,
            boolean
        >,
        ICheckoutBootstrapResult
    >(
        functions,
        'checkoutBootstrap',
    );
    return handleCheckoutBootstrap({
        test,
    }).then((result) => {
        const checkoutBootstrapResult = result.data as ICheckoutBootstrapResult;
        return checkoutBootstrapResult;
    }).catch((err) => {
        throw err;
    });
};

export default checkoutBootstrap;
